// src/app/utils/browser-utils.ts

/**
 * Get a cookie value by name
 * @param name Cookie name
 * @returns Cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Optional: Add more browser-related helpers here in the future
 * e.g., localStorage/sessionStorage wrappers, URL helpers, etc.
 */
